import { render, staticRenderFns } from "./ReceiverChartFields.vue?vue&type=template&id=6fbbdbe6"
import script from "./ReceiverChartFields.vue?vue&type=script&lang=js"
export * from "./ReceiverChartFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports